import type { ReactNode } from 'react'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { cn } from '@/lib/utils'

interface Props {
  id: number
  disabled?: boolean
  className?: string
  children: ReactNode
}

// Wraps a horizontal-strip item (block thumbnail / lesson pill) with dnd-kit
// sortable behavior. Listeners live on the wrapper; clicks still work because
// the PointerSensor uses a distance activation constraint.
export const SortableItem = ({ id, disabled, className, children }: Props) => {
  const { setNodeRef, listeners, transform, transition, isDragging } = useSortable({
    id,
    disabled,
  })

  return (
    <div
      ref={setNodeRef}
      // Состояние перетаскивания видно в DOM: `disabled` в dnd-kit выражается
      // ОТСУТСТВИЕМ слушателей (в jsdom ненаблюдаемым), а гейт «блок в прогоне
      // не перетаскивается» (C-1) обязан быть проверяем тестом.
      data-drag-disabled={disabled ? 'true' : 'false'}
      // Только сдвиг, без масштаба: Transform растягивал элемент под размер соседа.
      style={{ transform: CSS.Translate.toString(transform), transition }}
      className={cn(className, isDragging && 'z-10 opacity-70')}
      {...listeners}
    >
      {children}
    </div>
  )
}
